import { List, Map, fromJS } from "immutable"
import requestStatus from "../../constants/requestStatus"
import { onError, onGet, returnStateIfNoAction } from "../helpers"
import actionTypes from "../../actions/actionTypes"

const INIT_STATE  = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    data: Map({
        order: List(),
        items: Map()
    })
})


const onSuccess = (state, action)   => {
    return state.set('status', requestStatus.REQUEST_SUCCESS)
                .set('data', fromJS(action.payload))
}

const onUpdate = (state, action) => {
    const { payload } = action

    return state.set('status', requestStatus.REQUEST_SUCCESS)
                .setIn(['data', 'items', payload.pk], fromJS(payload))
}

                                               

const campaignsReducer = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type) {
        case actionTypes.NEWSLETTER_GET_CAMPAIGNS_REQUEST:
        case actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_REQUEST:
            return onGet(state, action);
        case actionTypes.NEWSLETTER_GET_CAMPAIGNS_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.NEWSLETTER_GET_CAMPAIGNS_ERROR:
        case actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_ERROR:
            return onError(state, action);
        case actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_SUCCESS:
            return onUpdate(state, action)
        default:
            return state;
    }

}

export default campaignsReducer